import { AnnualReportingDetails } from './../../../shared/models/manageWorkflow.model';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/core/services/api.service';
import { CoreService } from 'src/app/core/services/core.service';
import {
  GET_DASHBOARD_DETAILS,
  PUT_VERIFY_WORKFLOW_APPROVE_REJECTED_BY_ENDORSER,
  GET_PRINTER_PROOF_UPLOAD,
  RESET_WORKFLOW,
  START_WORKFLOW,
  UNLOCK_WORKFLOW,
  UPDATE_WORKFLOW,
  VIEW_LOG_HISTORY,
  WORKFLOW,
  PUT_PRINTER_PROOF_UPLOAD,
  GET_PRINTER_PROOF_DOWNLOAD,
  GET_NOMINATION_DETAILS,
  GET_CONSENT_TO_PUBLISH_DETAILS,
  UPDATE_PRINTER_PROOF_UPLOAD,
  SINGLE_START_WORKFLOW,
  PUT_SINGLE_APPROVE_BY_ENDORSER_2,
  PUT_SINGLE_REJECTED_BY_ENDORSER_2,
  PUT_SINGLE_REJECTED_BY_ENDORSER_1,
  PUT_SINGLE_APPROVE_BY_ENDORSER_1,
  PUT_SUBMIT_CONSENT_FOR_REVIEW_WORKFLOW,
  VERIFY_WORKFLOW_CONSENT_REJECT,
  CHECK_WORKFLOW_PRE_REQUISITES,
  GET_CONSENTED_USER_LIST,
  GET_CHECK_CONSENT_TO_PUBLISH_WORKFLOW_SUBMITTED,
  GET_WORKFLOW_LIST_COUNT,
  GET_UPLOAD_ON_BEHALF_OF_CONSENT_FILE,
  GET_WORKFLOW_USER_ON_BEHALF_FILE_DOWNLOAD,
} from 'src/app/shared/constants/data-capture-api-constant';
import {
  PUT_APPROVE_BY_ENDORSER_1,
  PUT_APPROVE_BY_ENDORSER_2,
  PUT_APPROVE_BY_ORC_WORKFLOW,
  PUT_REJECTED_BY_ENDORSER_1,
  PUT_REJECTED_BY_ENDORSER_2,
  PUT_REJECT_BY_ORC_WORKFLOW,
  PUT_SUBMIT_FOR_REVIEW_WORKFLOW,
} from './../../../shared/constants/data-capture-api-constant';
import {
  ASX_DATA_CAPTURE_REPORTING_CODE,
  DROPDOWN_DATA_CAPTURE_TABS_ASX_RESERVE,
  DROPDOWN_DATA_CAPTURE_TABS_ASX_RESOURCE,
  DROPDOWN_DATA_CAPTURE_TABS_US_SEC_RESERVE,
  DROPDOWN_DATA_CAPTURE_TABS_US_SEC_RESOURCE,
  OWNER_SHIPNUMBER_LEVEL_5_CP_RESERVE,
  OWNER_SHIPNUMBER_LEVEL_5_CP_RESOURCE,
  OWNER_SHIPNUMBER_LEVEL_5_QP_RESERVE,
  OWNER_SHIPNUMBER_LEVEL_5_QP_RESOURCE,
  US_SEC_DATA_CAPTURE_REPORTING_CODE,
} from 'src/app/shared/constants/constant';

@Injectable({
  providedIn: 'root',
})
export class ManageWorkflowService {
  constructor(
    private apiService: ApiService,
    private coreService: CoreService
  ) {}

  public backNavigationSubject = new Subject();

  public getFormDisableState(
    isLockedBy: number,
    workflowStatus: string,
    yearCode: string
  ): boolean {
    if (this.coreService.isConsumer) return true;

    if (workflowStatus != '1') return true;

    const isCurrentReportingCycleYearLock =
      sessionStorage.getItem('isCurrentReportingCycleYearLock') === '0';
    if (!isCurrentReportingCycleYearLock) return true;

    if (
      !this.coreService.isAdmin &&
      this.coreService.getLoggedInID() !== isLockedBy
    )
      return true;

    if (sessionStorage.getItem('currentReportingCycleYear') !== yearCode)
      return true;

    return false;
    // const result = (this.coreService.isAdmin || this.coreService.getLoggedInID() === isLockedBy) &&
    //   workflowStatus == '1' &&
    //   isCurrentReportingCycleYearLock &&
    //   sessionStorage.getItem('currentReportingCycleYear') == yearCode &&
    //   !this.coreService.isConsumer ? false : true;
    // return result;
  }

  public getDashboardDetails(
    workflowType: string,
    tabCode: string,
    yearCode: string,
    actionId: number,
    depositeId: number
  ): Observable<any> {
    return this.apiService.fetchData(
      `${GET_DASHBOARD_DETAILS}/${workflowType}/${tabCode}/${yearCode}/${actionId}/${depositeId}`
    );
  }

  public getWorkFlowListCount(
    yearCode: string,
    workflowType: string
  ): Observable<any> {
    return this.apiService.fetchData(
      `${GET_WORKFLOW_LIST_COUNT}/${yearCode}/${workflowType}`
    );
  }

  public getWorkflowDetails(workflowID: string, tabStatus: number): any {
    return this.apiService
      .fetchData(`${GET_DASHBOARD_DETAILS}/1/${tabStatus}/0`)
      .pipe(
        map((response) => {
          let data = {};
          response.forEach((element) => {
            if (element.workflowID === workflowID) {
              data = {
                nodeName: element.depositName,
                reportingName: element.reportingName,
                workflowStatus: element.workflowStatus,
              };
            }
          });
          return data;
        })
      );
  }

  public getPrinterProofFilesData(
    workflowID: string,
    yearCode: string
  ): Observable<any> {
    return this.apiService.fetchData(
      `${GET_PRINTER_PROOF_UPLOAD}/${workflowID}/${yearCode}`
    );
  }

  public postPrinterProofFilesData(PrinterProofFormData): Observable<any> {
    return this.apiService.postData(
      PUT_PRINTER_PROOF_UPLOAD,
      PrinterProofFormData
    );
  }

  public getPrinterProofDownload(id: number): Observable<any> {
    return this.apiService.fetchData(`${GET_PRINTER_PROOF_DOWNLOAD}${id}`);
  }

  public getWorkflowUserOnBehalfFilesDownload(
    wfID,
    isActive,
    loginID,
    fileName
  ): Observable<any> {
    return this.apiService.fetchData(
      `${GET_WORKFLOW_USER_ON_BEHALF_FILE_DOWNLOAD}/${wfID}/${isActive}/${loginID}/${fileName}`
    );
  }

  public updatePrinterProofData(
    PrinterProofFormData,
    id: number
  ): Observable<any> {
    return this.apiService.postData(
      `${UPDATE_PRINTER_PROOF_UPLOAD}${id}`,
      PrinterProofFormData
    );
  }

  public getViewLogHistory(
    workflowID: string,
    yearCode: string
  ): Observable<any> {
    return this.apiService.fetchData(
      `${VIEW_LOG_HISTORY}/${workflowID}/${yearCode}`
    );
  }
  public resetWorkflow(workflowData): Observable<any> {
    return this.apiService.postData(`${RESET_WORKFLOW}`, workflowData);
  }

  public updateWorkflow(workflowData): Observable<any> {
    return this.apiService.postData(`${UPDATE_WORKFLOW}`, workflowData);
  }

  public startWorkflow(startWorkflowData): Observable<any> {
    return this.apiService.postData(`${START_WORKFLOW}`, startWorkflowData);
  }

  public singleStartWorkflow(startWorkflowData): Observable<any> {
    return this.apiService.postData(
      `${SINGLE_START_WORKFLOW}`,
      startWorkflowData
    );
  }

  public unlockWorkflow(
    workflowID: string,
    yearCode: string,
    isAdmin: string
  ): Observable<any> {
    return this.apiService.postData(
      `${UNLOCK_WORKFLOW}/${workflowID}/${yearCode}/${isAdmin}`,
      {}
    );
  }

  public getFakeDashboardDetails(
    workflowType: string,
    tabCode: string,
    yearCode: string
  ): Observable<any> {
    return this.apiService.fakeFetchData(`${WORKFLOW}`);
  }

  public postFakeResetWorkflow(workflowData): Observable<any> {
    return this.apiService.fakePostData(`${WORKFLOW}`, workflowData);
  }

  public getWorkflowStatus(workflowData) {
    if (workflowData) {
      if (workflowData.workflowStatus === '-1') {
        workflowData.workflowStatusName = 'Not Ready';
      } else if (workflowData.workflowStatus === '0') {
        if (
          workflowData.wfLevel1UserID === '' ||
          !workflowData.wfLevel1UserID ||
          workflowData.wfLevel2UserID === '' ||
          !workflowData.wfLevel2UserID ||
          workflowData.wfLevel3UserID === '' ||
          !workflowData.wfLevel3UserID ||
          ((workflowData.wfLevel4UserID === '' ||
            !workflowData.wfLevel4UserID) &&
            workflowData.workflowType !== '2')
        ) {
          workflowData.workflowStatus = '102';
        }
        workflowData.workflowStatusName = 'Ready to Start';
      } else if (workflowData.workflowStatus === '1') {
        workflowData.workflowStatusName = 'With CP/QP';
      } else if (workflowData.workflowStatus === '2') {
        workflowData.workflowStatusName = 'With ORC';
      } else if (workflowData.workflowStatus === '3') {
        workflowData.workflowStatusName = 'With Endorser 1';
      } else if (workflowData.workflowStatus === '4') {
        workflowData.workflowStatusName = 'With Endorser 2';
      } else if (workflowData.workflowStatus === '5') {
        workflowData.workflowStatusName = 'With Endorser';
      } else if (workflowData.workflowStatus === '6') {
        workflowData.workflowStatusName = 'With Approver';
      } else if (workflowData.workflowStatus === '7') {
        workflowData.workflowStatusName = 'Complete';
      } else if (workflowData.workflowStatus === '8') {
        workflowData.workflowStatusName = 'Upload Printer Proof';
      } else if (workflowData.workflowStatus === '11') {
        workflowData.workflowStatusName = 'Upload Documents';
      } else if (workflowData.workflowStatus === '9') {
        workflowData.workflowStatusName = 'Processing Failed';
      }

      if (workflowData.wfLevel1Status === '1') {
        workflowData.wfLevel1UserName = workflowData.wfLevel1User
          ? `In Progress with ${workflowData.wfLevel1User}`
          : 'In Progress';
      } else if (workflowData.wfLevel1Status === '2') {
        if (workflowData.wfLevel1User) {
          if (workflowData.assignee.toString().indexOf(';') > -1) {
            const nameList = workflowData.assignee.split(';');
            workflowData.assignee = nameList[0];
          }
          if (workflowData.wfLevel1User.toString().indexOf(';') > -1) {
            const nameList = workflowData.wfLevel1User.split(';');
            const name = nameList[nameList.length - 1];
            workflowData.wfLevel1UserName = `Submitted by ${name}`;
          } else {
            workflowData.wfLevel1UserName = `Submitted by Unknown`;
          }
        }
      } else if (workflowData.wfLevel1Status === '3') {
        workflowData.wfLevel1UserName = workflowData.wfLevel1User
          ? `Rejected by ${workflowData.wfLevel1User}`
          : 'Rejected';
      } else {
        workflowData.wfLevel1UserName = workflowData.wfLevel1User
          ? `Not Started by ${workflowData.wfLevel1User}`
          : 'Not Started';
      }

      if (workflowData.wfLevel2Status === '1') {
        workflowData.wfLevel2UserName = workflowData.wfLevel2User
          ? `In Progress with ${workflowData.wfLevel2User}`
          : 'In Progress';
      } else if (workflowData.wfLevel2Status === '2') {
        if (workflowData.wfLevel2User) {
          if (workflowData.assignee.toString().indexOf(';') > -1) {
            const nameList = workflowData.assignee.split(';');
            workflowData.assignee = nameList[0];
          }
          if (workflowData.wfLevel2User.toString().indexOf(';') > -1) {
            const nameList = workflowData.wfLevel2User.split(';');
            const name = nameList[nameList.length - 1];
            workflowData.wfLevel2UserName = `Submitted by ${name}`;
          } else {
            workflowData.wfLevel2UserName = `Submitted by Unknown`;
          }
        }
      } else if (workflowData.wfLevel2Status === '3') {
        workflowData.wfLevel2UserName = workflowData.wfLevel2User
          ? `Rejected by ${workflowData.wfLevel2User}`
          : 'Rejected';
      } else {
        workflowData.wfLevel2UserName = workflowData.wfLevel2User
          ? `Not Started by ${workflowData.wfLevel2User}`
          : 'Not Started';
      }

      if (workflowData.wfLevel3Status === '1') {
        workflowData.wfLevel3UserName = workflowData.wfLevel3User
          ? `In Progress with ${workflowData.wfLevel3User}`
          : 'In Progress';
      } else if (workflowData.wfLevel3Status === '2') {
        workflowData.wfLevel3UserName = workflowData.wfLevel3User
          ? `Submitted by ${workflowData.wfLevel3User}`
          : 'Submitted by Unknown';
      } else if (workflowData.wfLevel3Status === '3') {
        workflowData.wfLevel3UserName = workflowData.wfLevel3User
          ? `Rejected by ${workflowData.wfLevel3User}`
          : 'Rejected';
      } else {
        workflowData.wfLevel3UserName = workflowData.wfLevel3User
          ? `Not Started by ${workflowData.wfLevel3User}`
          : 'Not Started';
      }
      if (workflowData.wfLevel4Status === '1') {
        workflowData.wfLevel4UserName = workflowData.wfLevel4User
          ? `In Progress with ${workflowData.wfLevel4User}`
          : 'In Progress';
      } else if (workflowData.wfLevel4Status === '2') {
        workflowData.wfLevel4UserName = workflowData.wfLevel4User
          ? `Submitted by ${workflowData.wfLevel4User}`
          : 'Submitted by Unknown';
      } else if (workflowData.wfLevel4Status === '3') {
        workflowData.wfLevel4UserName = workflowData.wfLevel4User
          ? `Rejected by ${workflowData.wfLevel4User}`
          : 'Rejected';
      } else {
        workflowData.wfLevel4UserName = workflowData.wfLevel4User
          ? `Not Started by ${workflowData.wfLevel4User}`
          : 'Not Started';
      }

      // assigning boolean value to disable the workflow.
      if (workflowData.workflowStatus === '-1') {
        workflowData.workflowBooleanStatus = true;
      }
    }
    return workflowData;
  }

  public getFilterData(workflowData): any {
    const mainFilterData = {};
    workflowData.forEach((cpqpnominationData, index) => {
      if (mainFilterData[cpqpnominationData.regionID]) {
        if (mainFilterData[cpqpnominationData.regionID].assets) {
          mainFilterData[cpqpnominationData.regionID].assets.push(
            cpqpnominationData.assetID
          );
          mainFilterData[cpqpnominationData.regionID].assets = _.uniq(
            mainFilterData[cpqpnominationData.regionID].assets,
            true
          );
        } else {
          mainFilterData[cpqpnominationData.regionID].assets = [];
          mainFilterData[cpqpnominationData.regionID].assets.push(
            cpqpnominationData.assetID
          );
        }
        if (!mainFilterData[cpqpnominationData.regionID].deposits) {
          mainFilterData[cpqpnominationData.regionID].deposits = {};
        }
        if (
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ]
        ) {
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ].push(cpqpnominationData.depositID);
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ] = _.uniq(
            mainFilterData[cpqpnominationData.regionID].deposits[
              cpqpnominationData.assetID
            ],
            true
          );
        } else {
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ] = [];
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ].push(cpqpnominationData.depositID);
        }
      } else {
        mainFilterData[cpqpnominationData.regionID] = {};
        mainFilterData[cpqpnominationData.regionID].regionID =
          cpqpnominationData.regionID;
        mainFilterData[cpqpnominationData.regionID].regionName =
          cpqpnominationData.regionName;
        if (mainFilterData[cpqpnominationData.regionID].assets) {
          mainFilterData[cpqpnominationData.regionID].assetName =
            cpqpnominationData.assetName;
          mainFilterData[cpqpnominationData.regionID].assets.push(
            cpqpnominationData.assetID
          );
          mainFilterData[cpqpnominationData.regionID].assets = _.uniq(
            mainFilterData[cpqpnominationData.regionID].assets,
            true
          );
        } else {
          mainFilterData[cpqpnominationData.regionID].assetName =
            cpqpnominationData.assetName;
          mainFilterData[cpqpnominationData.regionID].assets = [];
          mainFilterData[cpqpnominationData.regionID].assets.push(
            cpqpnominationData.assetID
          );
        }
        if (!mainFilterData[cpqpnominationData.regionID].deposits) {
          mainFilterData[cpqpnominationData.regionID].deposits = {};
        }
        if (
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ]
        ) {
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ].push(cpqpnominationData.depositID);
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ] = _.uniq(
            mainFilterData[cpqpnominationData.regionID].deposits[
              cpqpnominationData.assetID
            ],
            true
          );
        } else {
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ] = [];
          mainFilterData[cpqpnominationData.regionID].deposits[
            cpqpnominationData.assetID
          ].push(cpqpnominationData.depositID);
        }
      }
    });
    return mainFilterData;
  }

  /**
   * approveByORCWorkflow
   */
  public approveByORCWorkflow(data: ApproveWorkflowModel): Observable<any> {
    return this.apiService.postData(`${PUT_APPROVE_BY_ORC_WORKFLOW}`, data);
  }

  /**
   * rejectedByORCWorkflow
   */
  public rejectedByORCWorkflow(data: RejectWorkflowORCModel): Observable<any> {
    return this.apiService.postData(`${PUT_REJECT_BY_ORC_WORKFLOW}`, data);
  }

  /**
   * approveByEndorser1
   */
  public approveByEndorser1(data: ApproveWorkflowModel): Observable<any> {
    return this.apiService.postData(
      `${PUT_SINGLE_APPROVE_BY_ENDORSER_1}`,
      data
    );
  }

  public approveMultipleByEndorser1(
    data: ApproveWorkflowModel[]
  ): Observable<any> {
    return this.apiService.postData(`${PUT_APPROVE_BY_ENDORSER_1}`, data);
  }

  /**
   * approveByEndorser2
   */
  public approveByEndorser2(data: ApproveWorkflowModel): Observable<any> {
    return this.apiService.postData(
      `${PUT_SINGLE_APPROVE_BY_ENDORSER_2}`,
      data
    );
  }

  /**
   * approve multiple ByEndorser2
   */
  public approveMultipleByEndorser2(
    data: ApproveWorkflowModel[]
  ): Observable<any> {
    return this.apiService.postData(`${PUT_APPROVE_BY_ENDORSER_2}`, data);
  }

  /**
   * rejectedByEndorser1
   */
  public rejectedByEndorser1(data: ApproveWorkflowModel): Observable<any> {
    return this.apiService.postData(
      `${PUT_SINGLE_REJECTED_BY_ENDORSER_1}`,
      data
    );
  }

  public rejectedMultipleByEndorser1(
    data: ApproveWorkflowModel
  ): Observable<any> {
    return this.apiService.postData(`${PUT_REJECTED_BY_ENDORSER_1}`, data);
  }

  /**
   * rejectedByEndorser2
   */
  public rejectedByEndorser2(data: ApproveWorkflowModel): Observable<any> {
    return this.apiService.postData(
      `${PUT_SINGLE_REJECTED_BY_ENDORSER_2}`,
      data
    );
  }

  /**
   * rejectedMultipleByEndorser2
   */
  public rejectedMultipleByEndorser2(
    data: ApproveWorkflowModel[]
  ): Observable<any> {
    return this.apiService.postData(`${PUT_REJECTED_BY_ENDORSER_2}`, data);
  }

  /**
   * submitForSubmit
   */
  public submitForReview(data): Observable<any> {
    return this.apiService.postData(`${PUT_SUBMIT_FOR_REVIEW_WORKFLOW}`, data);
  }

  /**
   *
   * @param data
   * @returns
   */
  public checkConsentToPublishWorkflow(workflowID, yearcode): Observable<any> {
    return this.apiService.fetchData(
      `${GET_CHECK_CONSENT_TO_PUBLISH_WORKFLOW_SUBMITTED}/${workflowID}/${yearcode}`
    );
  }
  /**
   * submit consent to publish form
   */
  public submitConentToPublishForReview(data): Observable<any> {
    return this.apiService.postData(VERIFY_WORKFLOW_CONSENT_REJECT, data);
  }

  /**
   * verifyWorkflowApprovedRejectedByEndorser
   */
  public verifyWorkflowApprovedRejectedByEndorser(data): Observable<any> {
    return this.apiService.postData(
      `${PUT_VERIFY_WORKFLOW_APPROVE_REJECTED_BY_ENDORSER}`,
      data
    );
  }

  public verifyWorkflowApprovedRejectedByCPQP(data): Observable<any> {
    return this.apiService.postData(
      `${PUT_SUBMIT_CONSENT_FOR_REVIEW_WORKFLOW}`,
      data
    );
  }

  public getNominationDetails(
    workflowID: string,
    yearCode: string
  ): Observable<any> {
    return this.apiService.fetchData(
      `${GET_NOMINATION_DETAILS}/${workflowID}/${yearCode}`
    );
  }

  public getConsentPublishDetails(
    workflowID: string,
    yearCode: string,
    assignID: string
  ): Observable<any> {
    return this.apiService.fetchData(
      `${GET_CONSENT_TO_PUBLISH_DETAILS}/${workflowID}/${yearCode}/${assignID}`
    );
  }

  public getPrerequistDetails(workflowData): Observable<any> {
    return this.apiService.postData(
      `${CHECK_WORKFLOW_PRE_REQUISITES}`,
      workflowData
    );
  }

  public getConsentedUserList(workflowID, yearCode): Observable<any> {
    return this.apiService.fetchData(
      `${GET_CONSENTED_USER_LIST}/${workflowID}/${yearCode}`
    );
  }

  public uploadOnBehafConsentFile(data): Observable<any> {
    return this.apiService.postData(GET_UPLOAD_ON_BEHALF_OF_CONSENT_FILE, data);
  }

  /**
   * @description function call to get reporting tab code from workflow reporting name and type
   *
   * @param {string} reportingName
   * @param {string} type
   * @return {*}  {number}
   * @memberof ManageWorkflowService
   */
  public getTabCodeFromReportingName(
    reportingCode: string,
    ownershipType: string
  ): number {
    let tabCode;
    if (reportingCode === ASX_DATA_CAPTURE_REPORTING_CODE) {
      if (
        ownershipType &&
        ownershipType === OWNER_SHIPNUMBER_LEVEL_5_CP_RESOURCE
      ) {
        tabCode = DROPDOWN_DATA_CAPTURE_TABS_ASX_RESOURCE;
      } else if (
        ownershipType &&
        ownershipType === OWNER_SHIPNUMBER_LEVEL_5_CP_RESERVE
      ) {
        tabCode = DROPDOWN_DATA_CAPTURE_TABS_ASX_RESERVE;
      }
    } else if (reportingCode === US_SEC_DATA_CAPTURE_REPORTING_CODE) {
      if (
        ownershipType &&
        ownershipType === OWNER_SHIPNUMBER_LEVEL_5_QP_RESOURCE
      ) {
        tabCode = DROPDOWN_DATA_CAPTURE_TABS_US_SEC_RESOURCE;
      } else if (
        ownershipType &&
        ownershipType === OWNER_SHIPNUMBER_LEVEL_5_QP_RESERVE
      ) {
        tabCode = DROPDOWN_DATA_CAPTURE_TABS_US_SEC_RESERVE;
      }
    }
    return tabCode;
  }

  /**
   * updateSessionStorage
   */
  public updateSessionStorage(items: AnnualReportingDetails[]) {
    let oldItems: AnnualReportingDetails[] = JSON.parse(
      sessionStorage.getItem(`WORKFLOW_TABLE_GRID`)
    );
    if (!oldItems) {
      oldItems = [];
    }
    for (const item of items) {
      if (
        oldItems.findIndex(
          (x: AnnualReportingDetails) => x.workflowID === item.workflowID
        ) === -1
      ) {
        oldItems.push(item);
      }
    }
    sessionStorage.setItem(`WORKFLOW_TABLE_GRID`, JSON.stringify(oldItems));
  }

  /**
   * updateWorkflowStatus
   */
  public updateWorkflowStatus(
    items: AnnualReportingDetails[],
    requestedItems?: AnnualReportingDetails[]
  ) {
    const oldItems: AnnualReportingDetails[] = JSON.parse(
      sessionStorage.getItem(`WORKFLOW_TABLE_GRID`)
    );
    const updatedItems = [];
    if (oldItems) {
      for (const oldItem of oldItems) {
        const oldIndex = items.findIndex(
          (x) => x.workflowID === oldItem.workflowID
        );
        if (oldIndex > -1) {
          if (requestedItems) {
            const requestedIndex = requestedItems.findIndex(
              (x) => x.workflowID === oldItem.workflowID
            );
            if (requestedIndex > -1) {
              if (items[oldIndex].workflowStatus !== oldItem.workflowStatus) {
                if (requestedIndex > -1) {
                  requestedItems[requestedIndex].workflowStatus =
                    items[oldIndex].workflowStatus;
                  requestedItems[requestedIndex].workflowStatusName =
                    items[oldIndex].workflowStatusName;
                  updatedItems.push(oldItem);
                }
              } else {
                requestedItems[requestedIndex].workflowStatus = '101';
                requestedItems[requestedIndex].workflowStatusName =
                  'In progress';
                requestedItems[requestedIndex].isExternalApprover =
                  oldItem.isExternalApprover;
                requestedItems[requestedIndex].isNewCPQP = oldItem.isNewCPQP;
                items[oldIndex].workflowStatus = '101';
                items[oldIndex].workflowStatusName = 'In progress';
                items[oldIndex].isExternalApprover = oldItem.isExternalApprover;
                items[oldIndex].isNewCPQP = oldItem.isNewCPQP;
              }
            }
          } else {
            if (items[oldIndex].workflowStatus === oldItem.workflowStatus) {
              items[oldIndex].workflowStatus = '101';
              items[oldIndex].workflowStatusName = 'In progress';
              items[oldIndex].isExternalApprover = oldItem.isExternalApprover;
              items[oldIndex].isNewCPQP = oldItem.isNewCPQP;
            } else {
              updatedItems.push(oldItem);
            }
          }
        }
      }

      for (const item of updatedItems) {
        const index = oldItems.findIndex(
          (x) => x.workflowID === item.workflowID
        );
        if (index > -1) {
          oldItems.splice(index, 1);
        }
      }
      sessionStorage.setItem(`WORKFLOW_TABLE_GRID`, JSON.stringify(oldItems));
    }
  }

  public getFormFieldStatus(element: any): boolean {
    if (
      element.valueFormControl &&
      !(element.valueFormControl.valid || element.valueFormControl.disabled)
    ) {
      return false;
    }
    if (
      element.valueTextFormControl &&
      !(
        element.valueTextFormControl.valid ||
        element.valueTextFormControl.disabled
      )
    ) {
      return false;
    }
    return true;
  }
}

export interface ApproveWorkflowModel {
  yearCode: string;
  workflowID: string;
  loginID: string;
  rejectReason: string;
  actionID?: number;
}

export interface RejectWorkflowORCModel {
  isNomination: string;
  yearCode: string;
  workflowID: string;
  loginID: string;
  rejectReason: string;
}
